module.exports = __webpack_public_path__ + "media/src/images/icons/dash__white-d99fa26b3f1714e266fd04573defa92f.svg";